import isoCountries from "i18n-iso-countries";
import * as R from "ramda";

const renameKeys = (keysMap, obj) =>
  R.reduce(
    (acc, key) => R.assoc(keysMap(key) || key, obj[key], acc),
    {},
    R.keys(obj)
  );

let countries = [];

export const getCountries = () => countries;
export const getCountry = key => countries[key];

export const updateCountries = locale => {
  try {
    const lang = locale.split("-")[0];
    isoCountries.registerLocale(
      require(`i18n-iso-countries/langs/${lang}.json`)
    );
    countries = renameKeys(
      isoCountries.alpha2ToAlpha3,
      isoCountries.getNames(lang, {
        select: "official"
      })
    );
  } catch (err) {
    console.error(err);
  }
};
